// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";
import styled from "styled-components";
import { readableColor } from "polished";

const ListItem = styled.li`
  display: block;
  padding: ${props => props.theme.sizes.normal}rem;
  color: ${props => props.theme.colors.inverse};

  &:hover {
    background-color: ${props => props.theme.colors.primary};
    color: ${props => readableColor(props.theme.colors.primary)};
  }

  border-top: 1px solid ${props => props.theme.grayscale.g20};
  border-bottom: 1px solid ${props => props.theme.grayscale.g20};

  margin-top: -1px;
  &:first-child {
    margin-top: 0;
  }

  transition: background-color ${props => props.theme.transitions.quick} ease,
    color ${props => props.theme.transitions.quick} ease;
`;

export default ({ options, ...rest }: { options: string[]; rest?: any }) => (
  <ul {...rest}>
    {(options || []).map((item: string, index: number) => (
      <ListItem key={index}>{item}</ListItem>
    ))}
  </ul>
);
